import * as yup from 'yup';
import { FormValues } from '../CreateNewAffordabilityForm.types';

export default yup.object().shape<FormValues>({
  name: yup.string().required('This field is required.'),
  caseNumber: yup.string(),
});
